import { defineAsyncComponent } from 'vue'
import { tabOutlineLayoutDashboard } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type { MainFeatureTwin, FeatureConfig } from 'src/models'

export interface PowerBiDashboardFeatureTwin extends MainFeatureTwin {
  workspaceId?: string
  dashboardId: string
}

const featureConfig: FeatureConfig = {
  main: {
    mainComponent: defineAsyncComponent(() => import('./PowerBiDashboardFeatureMain.vue')),
    fullWidth: true,
    icon: tabOutlineLayoutDashboard,
    label: 'Dashboard'
  }
}

export default featureConfig
